import {
    InviteUserDto,
    PageableResult,
    PageableSearchOptions,
    Resource,
    UserDataDto,
    UserDto,
} from "@exibra/shared";
import { ApiService } from "../api/api.service";

class UserService extends ApiService {
    public async getUserData() {
        return this.axios.get<UserDataDto>(`/${Resource.User}/me`);
    }

    public async getUsers(tenantId: number, options: PageableSearchOptions) {
        const res = await this.axios.get<PageableResult<UserDto>>(`/${Resource.User}`, {
            params: { tenantId, ...options },
        });

        return res.data;
    }

    public async inviteUser(params: InviteUserDto) {
        return this.axios.post(`/${Resource.User}/invite`, params);
    }
}

export const userService = new UserService();
